import { Grid, useMediaQuery } from "@mui/material";
import { apiClient } from "api/apiClient";
import DealershipHero from "Pages/Dealership/DealershipHero";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { COLORS } from "theme";
import DealershipForm from "./DealershipForm/DealershipForm";
import DealershipInfo from "./DealershipInfo";
import DealershipThankYou from "./DealershipThankYou/DealershipThankYou";

const Dealership = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const [banner, setBanner] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formSubmit, setFormSubit] = useState(false);
  const [info, setInfo] = useState([]);
  const { t } = useTranslation();
  const [state, setState] = useState({
    dealershipName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "", // All numeric
    dob: "2024-12-21",
    educationalQualification: "BCA",
    street: "",
    pincode: "", // All numeric
    city: "",
    state: "",
    country: "India",
    partnership: "", // Selected partnership type
    stateAppliedFor: "",
    cityAppliedFor: "",
    currentBusinessDetails: "",
    industryExperience: "",
    yearsOfExperience: "", // All numeric
    companiesPartneredWith: "",
    annualTurnover: "", // All numeric
    landDetail: "", // Selected land detail
    additionalComments: "",
    approaxAmountToInvest: "", // Selected investment amount
    communicationConsent: "", // "true" or "false"
  });


  const dealershipDetails = useSelector(
    (state) => state?.Landing?.dealershipDetails
  );

  const getAction = (type) => {
    switch (type) {
      case "form":
        return setShowForm(true);
      case "submit": {
        setShowForm(false);
        setFormSubit(true);
        return;
      }
    }
  };

  useEffect(() => {
    apiClient.getDealershipBanner().then((res) => setBanner(res.data[0]));
    apiClient.getDealershipInfo().then((res) => setInfo(res.data[0]));
  }, []);

  return (
    <>
      <Grid item xs={12} style={{ padding: 0, paddingLeft: 0, marginTop: 71 }}>
        <DealershipHero banner={banner} small={small} />
      </Grid>
      {showForm ? (
        <Grid item xs={12}>
          <DealershipForm getAction={getAction} small={small} setState={setState} state={state} />
        </Grid>
      ) : formSubmit ? (
        <Grid item xs={12} style={{ padding: 0, paddingLeft: 0 }}>
          <DealershipThankYou
            dealershipDetails={dealershipDetails}
            small={small}
            state={state}
          />
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          style={{ padding: 0, paddingLeft: 0, background: COLORS.lightBlack }}
        >
          <DealershipInfo info={info} getAction={getAction} small={small} />
        </Grid>
      )}
      <Helmet>
        <title>{t("Euler Motors - Showrooms and Dealership Near Me")}</title>
        <link rel="canonical" href="https://www.eulermotors.com/en/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/te/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/dealership" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/dealership" />


        <link rel="publisher" href="https://www.eulermotors.com/dealership" />;
        <meta
          name="title"
          content={t("Euler Motors - Showrooms and Dealership Near Me")}
        />
        <meta
          name="description"
          content={t(
            "Discover a wide range of top-quality Three Wheeler Cargo at authorized Euler Motors dealer showrooms. Locate the nearest dealer showroom in your city!"
          )}
        />
        ​
      </Helmet>
    </>
  );
};

export default Dealership;
